const envConfig = {
  endpoint: 'https://sobrerodasapi.carrook.com.br/',
  endpointv2: 'https://sobrerodasapi.carrook.com.br/v2/',
};

export default envConfig;
